import React from 'react'

function Banner({ heading, bannerimg }) {
    return (
        <section className='relative page_banner'>
            <div className="banner-img">
                <img src={bannerimg} alt="Banner" />
            </div>
            <div className='container'>
                <h1 className='container'>{heading}</h1>
            </div>

        </section>
    )
}

export default Banner